import { reactive } from 'vue'

export const state = reactive({
  isAutheticated: false
})
